import { render, staticRenderFns } from "./OfferForRequest.vue?vue&type=template&id=6798c8f3&scoped=true"
import script from "./OfferForRequest.vue?vue&type=script&lang=ts"
export * from "./OfferForRequest.vue?vue&type=script&lang=ts"
import style0 from "./OfferForRequest.vue?vue&type=style&index=0&id=6798c8f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6798c8f3",
  null
  
)

export default component.exports